module.exports = __webpack_public_path__ + "img/contents_drive@2x.39caef47.png";